import { render, staticRenderFns } from "./OportunidadesPublicas.vue?vue&type=template&id=455c488a&scoped=true&"
import script from "./OportunidadesPublicas.vue?vue&type=script&lang=js&"
export * from "./OportunidadesPublicas.vue?vue&type=script&lang=js&"
import style0 from "./OportunidadesPublicas.vue?vue&type=style&index=0&id=455c488a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c488a",
  null
  
)

export default component.exports